import { render, staticRenderFns } from "./MultilangInput.vue?vue&type=template&id=3204206c&"
import script from "./MultilangInput.js?vue&type=script&lang=js&"
export * from "./MultilangInput.js?vue&type=script&lang=js&"
import style0 from "./MultilangInput.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports